<template>
  <div>
    <b-button
      variant="outline-primary"
      class="mb-3"
      @click="showModalImport = true"
    >
      <i class="ri-upload-2-line pl-1"></i>
      Import Assign To Fleet
    </b-button>
    <!-- Modal Export Import RH -->
    <b-modal
      v-model="showModalImport"
      title="Import Data"
      ok-title="Submit"
      :ok-disabled="isLoading"
      @ok="handleImport"
    >
      <template #modal-header>
        <h5 class="text-primary">Import Data</h5>
        <i
          class="fa fa-times cursor-pointer"
          @click="showModalImport = false"
        ></i>
      </template>
      <template>
        <div class="flex flex-column align-items-center">
          <b-form-file
            v-model="importFile"
            type="file"
            class="form-control"
            accept=".xlsx, .xls, .csv"
            :disabled="isLoading"
          />
          <small class="text-black">accept: .xlsx, .xls, .csv</small>
        </div>
        <b-button
          variant="outline-primary"
          class="mt-3 w-100"
          @click="handleExport"
          :disabled="isLoading"
        >
          <i class="fa fa-download"></i>
          Download Template Assign Library
          <b-spinner small v-if="isLoading" class="ml-2"></b-spinner>
        </b-button>
      </template>
    </b-modal>
    <!-- End Modal Export Import RH -->
    <!-- Loading Overlay -->
    <div v-if="isLoading" class="loading-overlay">
      <div class="spinner-container">
        <b-spinner type="grow" variant="primary" label="Loading..."></b-spinner>
        <p class="mt-2">Processing...</p>
      </div>
    </div>
  </div>
</template>

<script>
import { pmsActions } from '@/src/Utils/helper'

export default {
  name: 'ImportAssignJobToFleetModal',
  props: {
    refetch: {
      type: Function,
      required: false,
    },
  },
  data() {
    return {
      showModalImport: false,
      importFile: null,
      isLoading: false,
    }
  },
  methods: {
    ...pmsActions,
    async handleImport() {
      try {
        this.isLoading = true
        const formData = new FormData()
        formData.append('file', this.importFile)
        const res = await this.importAssignJobLibraryToFleet(formData)
        this.refetch()
        this.$swal({
          title: 'Import Data Success',
          icon: 'success',
        })
      } catch (error) {
        this.$swal({
          title: 'Failed Import Data!',
          type: 'error',
          text: 'Failed Import Data please check your file import!',
          icon: 'error',
        })
      } finally {
        this.isLoading = false
      }
    },
    async handleExport() {
      try {
        this.isLoading = true
        const res = await this.exportTemplateAssignJobToFleet()
        saveAs(res.data, 'import_template_assign_library_to_fleet.xlsx')
        this.$swal({
          title: 'Download Template Success',
          text: res.message,
          icon: 'success',
        })
      } catch (error) {
        this.$swal({
          title: 'Failed Export Template',
          icon: 'error',
        })
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style scoped>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.spinner-container {
  background-color: white;
  border-radius: 8px;
  padding: 40px;
  text-align: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.spinner-container p {
  color: #666;
  font-weight: 500;
  margin: 0;
}
</style>
